import { render, staticRenderFns } from "./NewRoles.vue?vue&type=template&id=53c31a4e&scoped=true&"
import script from "./NewRoles.vue?vue&type=script&lang=js&"
export * from "./NewRoles.vue?vue&type=script&lang=js&"
import style0 from "./NewRoles.vue?vue&type=style&index=0&id=53c31a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c31a4e",
  null
  
)

export default component.exports